import React from 'react';

import {useHistory} from 'react-router-dom';

import CloseImg from '../../../../../../../../../../assets/icons/addadminclose.svg';

import {AddStudentHeaderContainer} from './elements';

export const AddStudentHeader = () => {
  const history = useHistory();

  return (
    <AddStudentHeaderContainer>
      <div className="add-student-header">
        <div className="add-student-title">
          <div>
            <span className="add-student-name">Add a Class</span>
          </div>
          <div>
            <button
              className="btn"
              onClick={() => {
                history.goBack();
              }}
              type="button"
              id="close"
            >
              <img alt="Options" src={CloseImg} />
            </button>
          </div>
        </div>
      </div>
    </AddStudentHeaderContainer>
  );
};
